import React from "react";

const ExpandIcon = () => {
  return (
    <svg width="14" height="14" viewBox="0 0 17 16" fill="none">
      <path
        d="M2.19982 14.2666L6.88436 9.61791"
        stroke="#5A5A5A"
        stroke-width="1.33333"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M14.6845 2.01144L9.99991 6.66016"
        stroke="#5A5A5A"
        stroke-width="1.33333"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M5.19604 15.2781L1.19607 15.2627L1.21142 11.2628"
        stroke="#5A5A5A"
        stroke-width="1.33333"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M11.6882 1L15.6882 1.01535L15.6729 5.01532"
        stroke="#5A5A5A"
        stroke-width="1.33333"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default ExpandIcon;
